import React from 'react'
import { Skeleton, Box } from '@mui/material'
import { ButtonIconSeeker } from '@ui-seeker/core'

import { useToast } from '@hooks'
import { BACKEND_APIS } from '@constants'
import { TitleWithPopover, AppTableSeeker } from "@components";
import { simpleValueColumn, dateColumn , chipColumn, sitesScopeColumn, countryColumn} from './columns'
import {useUserTableFilters} from "./@hooks";
import {userDetailsFilters} from "../@signals";
import {UserDetailModal, CreateUserButton} from "./@components";


export default function UsersTable() {

    const { data, isLoading, requestSend} = useUserTableFilters()
    const { showToast } = useToast()

    if (isLoading) return <Skeleton variant="rectangular" height={500} />
    if (!data.length && !requestSend) return <></>

    const columns = [
        simpleValueColumn('userID', 'User ID'),
        simpleValueColumn('userName', 'User Name', true),
        simpleValueColumn('password', 'Password'),
        simpleValueColumn('email', 'Email'),
        simpleValueColumn('role', 'Role'),
        ...countryColumn(),
        dateColumn('dateCreated', 'Date Created'),
        chipColumn('access', 'Access', 4, true),
        chipColumn('skuGroups', 'Sku Groups', 2),
        sitesScopeColumn()
    ]

    return <Box id="users-info-table">
        <AppTableSeeker
            data={data}
            title={<TitleWithPopover title={"Users Info for customer " + userDetailsFilters.value?.name} />}
            columns={columns}
            options={{
                onDownload: () => showToast.promiseExcel(`${BACKEND_APIS.MANAGEMENT}/customer/user-context_excel`, userDetailsFilters.value),
                viewColumns: false,
                customToolbar: () => <Box display={"flex"} alignItems={"center"}>
                    <CreateUserButton
                        customerID={userDetailsFilters.value?.customerID}
                        customerName={userDetailsFilters.value?.name}
                    />
                    <ButtonIconSeeker
                        icon="circle-xmark"
                        onClick={() => {
                            userDetailsFilters.value = {}
                        }}
                        tooltip="Close Users Details"
                        sx={{ ml: 1 }}
                    />
                </Box>
            }}
        />
        <UserDetailModal />
    </Box>
}